import {OpData, OpType, OpTypeToObject} from "./Operation_gen";
import {CellContent} from "./CellContent";
import {SerializableJourneyMap} from "./SerializableJourneyMap";
import {ContentHeader} from "./ContentHeader";
import {Funnel} from "./Funnel";
import {RoleHeader} from "./RoleHeader";
import {ContentKeyPair, RoleKeyPair} from "./Keys";

export class Operation {

    private id: string | null;
    public readonly type: OpType;
    public readonly data: OpData;

    constructor(type: OpType, data: OpData, id?: string) {
        this.id = id ?? null;
        this.type = type;
        this.data = data;
    }

    get Id(): string | null {
        return this.id;
    }

    setId(id: string) {
        return this.id = id;
    }

    static fromStoredData(op: { type: string, data: string, id?: string }) {
        const fixed_data = Operation.fixStoredData(op.type, JSON.parse(op.data));
        const self = OpTypeToObject(op.type, fixed_data);
        if (op.id !== undefined) {
            self.setId(op.id);
        }
        return self;
    }

    /**
     * 後方互換を保つための OpData 修正処理
     *
     * リリース前には一度まっさらにする
     *
     * @param type
     * @param obj
     */
    static fixStoredData(type: string, obj: any) {

        // if (type === 'UpdateCellContent') {
        //     if (obj.width === undefined) {
        //         obj.width = null;
        //     }
        //     if (obj.height === undefined) {
        //         obj.height = null;
        //         console.log("data fixed", obj);
        //     }
        // }

        return obj;
    }
}

export function converter(obj: any, type: string) {

    switch (type) {
        case "number | null":
            if (!(typeof obj === 'number' || obj === null)) {
                throw new Error("mismatch type");
            }
            return obj;
        case "string":
        case "ContentKey":
        case "FunnelKey":
        case "RoleKey":
        case "EditorType":
            if (!(typeof obj === 'string')) {
                throw new Error("mismatch type");
            }
            return obj;
        case "RoleKey | null":
            if (!(typeof obj === 'string' || obj === null)) {
                throw new Error("mismatch type");
            }
            return obj;
        case "FunnelKey[]":
        case "RoleKey[]":
        case "ContentKey[]":
            if (obj.length === undefined || obj.length === 0) {
                throw new Error("mismatch type");
            }
            for (const i of obj as any[]) {
                if (!(typeof i === 'string')) {
                    throw new Error("mismatch type");
                }
            }
            return obj;
        case "number":
            if (!(typeof obj === 'number')) {
                throw new Error("mismatch type");
            }
            return obj;
        case "boolean":
            if (!(typeof obj === 'boolean')) {
                throw new Error("mismatch type");
            }
            return obj;
        case ContentKeyPair.__CLASS__:
            return new ContentKeyPair(obj.line_key, obj.funnel_key);
        case RoleKeyPair.__CLASS__:
            return new RoleKeyPair(obj.line_key, obj.funnel_key);
        case CellContent.__CLASS__:
            return CellContent.fromJSON(obj);
        case SerializableJourneyMap.__CLASS__:
            return SerializableJourneyMap.fromJSON(obj);
        case Funnel.__CLASS__:
            return Funnel.fromJSON(obj);
        case ContentHeader.__CLASS__:
            return ContentHeader.fromJSON(obj);
        case RoleHeader.__CLASS__:
            return RoleHeader.fromJSON(obj);
    }
    throw new Error("unknown type");
}
